import { styled } from '@linaria/react';
import { space } from '../../theme/tokens';

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-500']};
`;

export const InclusionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-300']};
`;

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-200']};
`;

export const NoticeSlot = styled.div`
  & > * {
    margin-block: 0;
  }
`;
